<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap
    >
      <v-flex xs12 md12>
        <material-card
        
          color="green"
          title="Lecture Details"
          text=""
        >
        <v-layout row>
          <v-flex xs12 md4>
              <video width="320" height="240" controls>
              <source :src="'http://api.bacbonschool.com/api/getVideo/' + lectureDetails.url" type="video/mp4">
              <source :src="'http://api.bacbonschool.com/api/getVideo/' + lectureDetails.url" type="video/ogg">
            Your browser does not support the video tag.
            </video>
          </v-flex>
          <v-flex xs12 md4>
        <h3>{{ lectureDetails.title }} </h3>
        <small>{{ lectureDetails.description }}</small>
          </v-flex>
          
          <v-flex xs12 md4>
        <b>Course :</b> {{ lectureDetails.course.name }} <br>
        <b>Subject :</b>{{ lectureDetails.subject.name }} <br>
        <b>Chapter :</b>{{ lectureDetails.chapter.name }} <br>
         </v-flex>
        </v-layout>

        </material-card>

            <v-snackbar
              :color="color"
              :bottom="bottom"
              :top="top"
              :left="left"
              :right="right"
              v-model="snackbar"
              dark
            >
              <v-icon
                color="white"
                class="mr-3"
              >
                mdi-bell-plus
              </v-icon>
              <div>{{ noticeMessage }}</div>
              <v-icon
                size="16"
                @click="snackbar = false"
              >
                mdi-close-circle
              </v-icon>
            </v-snackbar>
      </v-flex>
   
           <LectureScript :lecture="lectureDetails" ::Value="valueObj"/>
          <LectureExam :lecture="lectureDetails" />
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import FormLecture from '@/views/FormLecture'
import FormScript from '@/views/FormScript'
import LectureScript from '@/views/LectureScript'
import LectureExam from '@/views/LectureExam'
import Form from '@/views/Form'

export default {
  components: {
    Form,
    FormLecture,
    LectureScript,
    LectureExam,
    FormScript
  },
  computed: {
    // ...mapGetters("courses", ["course", "name", "courseList"]),
    ...mapState('lectures', ['lectureDetails']),
  },
  mounted () {
    this.getLectureDetails(this.$route.params.id)
  },
  data () {
    return {
    color: null,
    colors: [
      'warning'
    ],
    top: true,
    bottom: false,
    left: false,
    right: false,
    snackbar: false,
      
    headers: [
      {
        sortable: true,
        text: 'Title',
        value: 'title'
      },
      {
        sortable: false,
        text: 'Description',
        value: 'description'
      },
      {
        sortable: true,
        text: 'Price',
        value: 'price'
      },
    ],
    
      dialog: false,
      noticeMessage: '',
      item: {
        'title': 'Add new Lecture Video',
        'subTitle': 'This is the subtitle',
        'width': 'md6',
        'submitText' : 'Submit'
      },
      valueObj: {
        'chapter_id' : this.$route.params.id,
        'course_id' : 1,
        'subject_id' : 1
       },
    }
  },
  created () {
  },

  methods: {
    ...mapActions("lectures", ["getLectureDetails"]),
 
    getBackData (data) {
      this.LectureScript(data).then((response) => {
        console.log(response)
        if (response.status == 'OK') {
          this.getLectureListByChapterId(this.$route.params.id)
          this.dialog = false
            this.color= 'success'
          this.noticeMessage = response.messages
          this.snack('top')
        } else {
          this.noticeMessage = response.messages
          this.snack('top')
        }
      }).catch((err) => {
        console.log(err)
      })
    },

    snack (...args) {
      this.top = false
      this.bottom = false
      this.left = false
      this.right = false

      for (const loc of args) {
        this[loc] = true
      }


      this.snackbar = true
    }
  }
}
</script>
